'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2017/7/7.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _GoeasyPreloadImg = require('../GoeasyPreloadImg/GoeasyPreloadImg');

var _GoeasyPreloadImg2 = _interopRequireDefault(_GoeasyPreloadImg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Link } from 'react-router';

var NewMediumListInfo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(NewMediumListInfo, _Component);

  function NewMediumListInfo() {
    (0, _classCallCheck3.default)(this, NewMediumListInfo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(NewMediumListInfo).call(this));

    _this.state = {
      hover: false
    };
    return _this;
  }

  (0, _createClass3.default)(NewMediumListInfo, [{
    key: 'mouseOver',
    value: function mouseOver() {
      this.setState({
        hover: true
      });
    }
  }, {
    key: 'mouseLeave',
    value: function mouseLeave() {
      this.setState({
        hover: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./NewMediumListInfo.scss');
      var _props = this.props;
      var data = _props.data;
      var index = _props.index;
      var key = _props.key;
      var defaultImg = _props.defaultImg;
      var hover = this.state.hover;

      var rightClassName = '';
      if ((index + 1) % 4 === 0) {
        rightClassName = styles.mr0;
      }
      var hudsClassName = styles.huds;
      var qcDicClassName = styles.qcDiv;
      if (hover === true) {
        hudsClassName = hudsClassName + ' ' + styles.hongd;
        qcDicClassName = qcDicClassName + ' ' + styles.qchong;
      } else if (hover === false) {
        hudsClassName = hudsClassName + ' ' + styles.hong;
        qcDicClassName = qcDicClassName + ' ' + styles.qchongd;
      }
      return _react2.default.createElement(
        'li',
        { className: styles.component + ' ' + rightClassName, key: key,
          onMouseOver: this.mouseOver.bind(this), onMouseLeave: this.mouseLeave.bind(this) },
        _react2.default.createElement(
          'dl',
          null,
          _react2.default.createElement(
            'dd',
            null,
            _react2.default.createElement(_GoeasyPreloadImg2.default, { defaultImg: defaultImg,
              img: data.img || 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg10.jpg' }),
            data.qc ? _react2.default.createElement(
              'div',
              { className: qcDicClassName },
              _react2.default.createElement('img', { src: data.qc, alt: '', className: styles.img_er })
            ) : _react2.default.createElement(
              'div',
              { className: qcDicClassName },
              _react2.default.createElement(
                'div',
                { className: styles.wechatTxtDiv },
                _react2.default.createElement(
                  'p',
                  {
                    className: styles.txt1 },
                  '请打开手机微信搜索微信公众号'
                ),
                _react2.default.createElement(
                  'p',
                  {
                    className: styles.txt2 },
                  data.wechat
                ),
                _react2.default.createElement(
                  'p',
                  { className: styles.txt3 },
                  '添加关注'
                )
              )
            )
          ),
          _react2.default.createElement(
            'dt',
            { style: { position: 'relative' } },
            _react2.default.createElement(
              'div',
              { className: hudsClassName },
              _react2.default.createElement(
                'div',
                { className: styles.hudDesigner },
                _react2.default.createElement(
                  'h3',
                  { className: styles.name },
                  data.name
                ),
                _react2.default.createElement(
                  'h3',
                  { className: styles.designerShop },
                  data.slogan
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.hudd },
              _react2.default.createElement(
                'div',
                { className: styles.hud },
                _react2.default.createElement(
                  'h3',
                  { className: styles.wechat },
                  '公众号 '
                ),
                _react2.default.createElement(
                  'h3',
                  { className: styles.wechat, style: { paddingTop: '7px' } },
                  data.wechat
                ),
                _react2.default.createElement(
                  'h3',
                  { className: styles.funNum },
                  '粉丝 ' + data.funs
                )
              )
            )
          )
        )
      );
    }
  }]);
  return NewMediumListInfo;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  index: _react.PropTypes.number,
  defaultImg: _react.PropTypes.string,
  key: _react.PropTypes.string
}, _temp);
exports.default = NewMediumListInfo;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/NewMediumListInfo/NewMediumListInfo.js
 ** module id = 1378
 ** module chunks = 0
 **/